import { render } from "./HowToBuy.vue?vue&type=template&id=6f5312f4&scoped=true"
import script from "./HowToBuy.vue?vue&type=script&lang=js"
export * from "./HowToBuy.vue?vue&type=script&lang=js"

import "./HowToBuy.vue?vue&type=style&index=0&id=6f5312f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5312f4"]])

export default __exports__